import React from 'react'
import PropTypes from 'prop-types'
import CloudsLeft from 'assets/images/login/clouds-left.svg'
import CloudsRight from 'assets/images/login/clouds-right.svg'
import SceneLeft from 'assets/images/login/scene-left.png'
import SceneRight from 'assets/images/login/scene-right.png'
import GlobeIcon from 'assets/images/login/globe.svg'
import ChevronIcon from 'assets/images/login/chevron.svg'
import 'containers/sigin-in/SignIn.scss'

function AuthScreen({ children }) {
  return (
    <div className='login-screen'>
      <img
        className='login-clouds login-clouds-left'
        src={CloudsLeft}
        width={370.732}
        height={280.672}
        alt=''
      />
      <img
        className='login-clouds login-clouds-right'
        src={CloudsRight}
        width={417.822}
        height={280.456}
        alt=''
      />
      <img
        className='login-scene login-scene-left'
        src={SceneLeft}
        width={692}
        height={312}
        alt=''
      />
      <img
        className='login-scene login-scene-right'
        src={SceneRight}
        width={749}
        height={353}
        alt=''
      />
      <div className='login-topbar'>
        <p>© 2026 XLR8</p>
        <div className='login-language'>
          <img src={GlobeIcon} width={20} height={20} alt='' />
          <span>ENG</span>
          <img src={ChevronIcon} width={20} height={20} alt='' />
        </div>
      </div>
      {children}
    </div>
  )
}

AuthScreen.propTypes = {
  children: PropTypes.node.isRequired,
}

export default AuthScreen
